import { render, staticRenderFns } from "./Pabbly.vue?vue&type=template&id=ceb0a1e2&scoped=true"
import script from "./Pabbly.vue?vue&type=script&lang=js"
export * from "./Pabbly.vue?vue&type=script&lang=js"
import style0 from "./Pabbly.vue?vue&type=style&index=0&id=ceb0a1e2&prod&scoped=true&lang=css"
import style1 from "./Pabbly.vue?vue&type=style&index=1&id=ceb0a1e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceb0a1e2",
  null
  
)

export default component.exports